import Css from "./style.module.scss";

import signUpDemoIcon from "assets/signUpDemoIcon.svg";
import signUpPaymentIcon from "assets/signUpPaymentIcon.svg";

import * as Icons from "@phosphor-icons/react";
import { getActiveOrganization } from "selectors/organizations";
import { getTextsData } from "selectors/texts";
import { getUserData } from "selectors/user";
import { useDispatch, useSelector } from "react-redux";
import BillingIssues from "const/BillingIssues";
import Button from "nlib/ui/Button";
import Environment from "utils/Environment";
import PostSignUpNew from "nlib/common/PostSignUpNew";
import React, { useCallback, useState } from "react";
import StripeActions from "actions/StripeActions";
import classNames from "classnames";

const FETCHING_DATA_TIMEOUT = 10000;

const { CALENDLY_URL } = Environment.getProcessEnvVars();

const PostSignUp = ({ className }) => {
  const dispatch = useDispatch();

  const { uiTexts, messages } = useSelector(getTextsData);

  const activeOrganization = useSelector(getActiveOrganization);

  const userData = useSelector(getUserData);

  const [fetchingData, setFetchingData] = useState(false);

  const [
    postSignUpModalDescriptionA,
    postSignUpModalDescriptionB,
    postSignUpModalDescriptionC,
    postSignUpModalDescriptionD
  ] = messages.postSignUpModalDescription;

  const [postSignUpModalSalesInfoA, postSignUpModalSalesInfoB] = messages.postSignUpModalSalesInfo;

  const [
    postSignUpModalPaymentInfoA,
    postSignUpModalPaymentInfoB,
    postSignUpModalPaymentInfoC,
    postSignUpModalPaymentInfoD
  ] = messages.postSignUpModalPaymentInfo;

  const billingIssue = activeOrganization.billingId && !activeOrganization.subscriptionId;

  const paymentFailed = activeOrganization.billingIssue === BillingIssues.PAYMENT_FAILED;

  const billingIssueDescription = paymentFailed ? postSignUpModalDescriptionC : postSignUpModalDescriptionD;

  const handleTalkToSalesButtonClick = useCallback(() => {
    window.location.href = CALENDLY_URL;
  }, []);

  const handleAddPaymentMethodButtonClick = useCallback(() => {
    setFetchingData(true);
    setTimeout(() => {
      setFetchingData(false);
    }, FETCHING_DATA_TIMEOUT);
    dispatch(StripeActions.createSetupCheckoutSession()).then((sessionUrl) => {
      window.location.href = sessionUrl;
    });
  }, [dispatch]);

  if (activeOrganization.newPrices && (!billingIssue || userData.holdUser)) return <PostSignUpNew className={className} />;

  return (
    <div className={classNames(Css.postSignUp, className, billingIssue && Css.withBillingIssue)}>
      <div className={Css.content}>
        <div className={Css.card}>
          <div className={Css.block}>
            <div className={Css.description}>
              <div className={Css.title}>{postSignUpModalDescriptionA}</div>
              {!billingIssue && <p>{postSignUpModalDescriptionB}</p>}
            </div>
            {billingIssue && (
              <div className={Css.row}>
                <div className={Css.col}>
                  <p className={Css.billingIssueNotice}>
                    <Icons.Warning />
                    <span>{billingIssueDescription}</span>
                  </p>
                </div>
              </div>
            )}
            <div className={Css.row}>
              <div className={Css.col}>
                <img src={signUpDemoIcon} />
                <h6>{postSignUpModalSalesInfoA}</h6>
                <p className={Css.optionDescription}>{postSignUpModalSalesInfoB}</p>
                <Button
                  large
                  className={classNames(Css.button, Css.talkToSalesButton)}
                  onClick={handleTalkToSalesButtonClick}>
                  <span>{uiTexts.talkToSales}</span>
                  <Icons.CaretRight />
                </Button>
              </div>
              <div className={Css.col}>
                <img src={signUpPaymentIcon} />
                <h6>{postSignUpModalPaymentInfoA}</h6>
                <p className={Css.optionDescription}>
                  {billingIssue ? postSignUpModalPaymentInfoD : postSignUpModalPaymentInfoB}
                </p>
                {!billingIssue && <p className={Css.paymentNotice}>{postSignUpModalPaymentInfoC}</p>}
                <Button
                  large
                  primary
                  disabled={fetchingData}
                  className={Css.button}
                  onClick={handleAddPaymentMethodButtonClick}>
                  {fetchingData
                    ? `${uiTexts.redirectingPleaseWait}...`
                    : (billingIssue ? uiTexts.updatePaymentMethod : uiTexts.addPaymentMethod)}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(PostSignUp);
